import styled from 'styled-components';
import colors from 'styles/colors';

export const TooltipPointer = styled.div`
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 9px 9px 0 9px;
  border-style: solid;
  border-color: ${colors.tooltipBackground} transparent transparent transparent;
  z-index: 100;
`;

export const TooltipWrapper = styled.div`
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 116px;
  top: -9px;
  transform: translateX(-50%) translateY(-100%);
  background: ${colors.tooltipBackground};
  color: #fff;
  padding: 8px 12px;
  font-size: 11px;
  line-height: 1.2;
  width: 254px;
  border-radius: 2px;
  pointer-events: none;
  text-align: left;

  span::after {
    content: none;
  }
`;
